import React,{useState,useEffect} from "react";
import { makeStyles } from 'tss-react/mui';
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import FormHelperText from "@mui/material/FormHelperText";

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
  },
  textField: {
    "& .MuiInputBase-input::placeholder": {
      fontSize: "0.85em",
      color: theme.palette.text.disabled,
      opacity: 1,
    },
  },
  // An address, as a soft pill; red when it is not a valid address.
  chip: {
    "&.MuiChip-root": {
      height: 26,
      fontSize: 13,
      color: theme.palette.tone.brand.main,
      backgroundColor: theme.palette.tone.brand.soft,
    },
    "& .MuiChip-deleteIcon": {
      fontSize: 17,
      color: "inherit",
      opacity: 0.6,
      "&:hover": {
        color: "inherit",
        opacity: 1,
      },
    },
  },
  chipInvalid: {
    "&.MuiChip-root": {
      color: theme.palette.tone.danger.main,
      backgroundColor: theme.palette.tone.danger.soft,
    },
  },
  helper: {
    marginTop: 4,
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  errorText: {
    color: theme.palette.tone.danger.main,
  },
}));

const EmailAutocomplete = (props) => {
  const { classes, cx } = useStyles();
    const {
      placeholder,
      setValue,
      value,
      hasError,
      setHasError
    } = props;
    const [inputValue, setInputValue] = useState("");
    
    
    const isEmailValid = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    
    const handleChange = (event, emails) => {
      setValue(emails);
      event.persist();
    };

    const handleInputChange = (event,newInputValue) => {
      const options = newInputValue.split(/[ ,]+/);
      const fieldValue = value
        .concat(options)
        .map((x) => x.trim())
        .filter((x) => x);
      if (options.length > 1) {
        handleChange(event, fieldValue);
      } else {
        setInputValue(newInputValue);
      }
    };

    const handleKeyDown = (event) => {
      switch (event.key) {
        case "Tab": {
          if(inputValue!=="") event.preventDefault();
          if (inputValue.length > 0) {
            handleChange(event, value.concat([inputValue]));
          }
          break;
        }
        default:
        }
    };

    const checkValidity = ()=>{
      let test = value.map(email => {
        if (!isEmailValid(email)) return true;
        return false;
      });
      
      if(test.indexOf(true)!==-1){
        setHasError(true)
      }else setHasError(false);
    }

    useEffect(()=>{
      checkValidity();
    })
    
    return (
      <React.Fragment>
        <Autocomplete
          className={classes.root}
          multiple={true}
          id="email-autocomplete"
          options={[]}
          limitTags={3}
          groupBy={(option) => option.firstLetter}
          value={value}
          freeSolo
          // An address that was typed but not confirmed counts when the field
          // is left, for example to press Send.
          autoSelect
          size="small"
          renderValue={(emails, getItemProps) => {
            return emails.map((email, index) => {
              // React wants the key passed directly, not inside the spread.
              const { key, ...itemProps } = getItemProps({ index });
              return (
              <Chip
                key={key}
                deleteIcon={<CancelIcon onClick={checkValidity} />}
                label={email}
                size="small"
                {...itemProps}
                // After the spread, which carries a class of its own.
                className={cx(itemProps.className, classes.chip, !isEmailValid(email) && classes.chipInvalid)} />
              );
            });
          }}
          inputValue={inputValue}
          onChange={handleChange}
          onInputChange={handleInputChange}
          renderInput={(params) => {
            params.slotProps.htmlInput.onKeyDown = handleKeyDown;
            return (
              <TextField
                { ...params }
                label={placeholder}
                placeholder={value.length === 0 ? "name@example.com" : ""}
                variant="outlined"
                fullWidth
                autoFocus
                error={hasError}
                className={classes.textField}
                slotProps={{ ...params.slotProps, inputLabel: { ...(params.slotProps && params.slotProps.inputLabel), shrink: true } }}
              />
            );
          }}
        />
        <FormHelperText className={cx(classes.helper, hasError && classes.errorText)}>
          {hasError
            ? "One of the addresses is not a valid email address."
            : "Separate several addresses with a comma, a space or Enter."}
        </FormHelperText>
      </React.Fragment>
    );
}

export default EmailAutocomplete;